import React, { createContext, useContext, useMemo } from 'react';
import { apiSlice } from '../../api/apiSlice';
import { physicianDashboardSlice } from '../../api/physicianDashboardSlice';
import { staffReviewSlice } from '../../api/staffReviewSlice';

const ApiContext = createContext();

export function ApiContextProvider({ children, area }) {
    const contextValue = useMemo(() => {
        let endpoints, sliceName, userType;

        switch(area) {
        case 'admin':
            endpoints = apiSlice.endpoints;
            sliceName = 'apiSlice';
            userType = 'user';
            break;
        case 'physician':
            endpoints = physicianDashboardSlice.endpoints;
            sliceName = 'physicianDashboardSlice';
            userType = 'dashboardUser';
            break;
        case 'staffReview':
            endpoints = staffReviewSlice.endpoints;
            sliceName = 'staffReviewSlice';
            userType = 'staffReviewUser';
            break;
        default:
            throw new Error(`Unknown API area: ${area}. Must be one of: admin, physician, staffReview`);
        }

        return {
            area,
            endpoints,
            sliceName,
            userType,
        };
    }, [area]);

    return (
        <ApiContext.Provider value={contextValue}>
            {children}
        </ApiContext.Provider>
    );
}

export function useApiContext() {
    const context = useContext(ApiContext);
    if (context === undefined) {
        throw new Error('useApiContext must be used within an ApiContextProvider');
    }
    return context;
}